import { GET_CPTY } from '../actionTypes'
import { Cpty } from '../reducers/cpty'


export const getCptyAction = (cpty: Cpty[]) => ({ type: GET_CPTY, payload: cpty })
